<script>
	import { createEventDispatcher } from 'svelte';
	export let links = [];
	export let className = '';

	const dispatch = createEventDispatcher();
</script>

<!-- dont render, if there's only 1 page (first, previous, 1, next, last) or if theres not exactly 3 for cursor pagination (first, previous, next) -->
{#if links && (links.length == 3 || links.length >= 5)}
	<!-- DESKTOP: all available links -->
	<div class="hidden md:flex justify-center gap-x-1 {className}">
		{#each links as { disabled, active, label, page } (label)}
			<button
				disabled={disabled ?? false}
				class="h-10 text-sm border rounded focus:outline-none flex justify-center items-center font-semibold"
				class:w-9={label.toString().length <= 3}
				class:px-3={label.toString().length > 3}
				class:opacity-50={disabled && !active}
				class:opacity-70={active}
				class:text-black={!disabled || active}
				class:bg-white={!active}
				class:bg-primary={active}
				class:text-gray-200={disabled && !active}
				class:hover:bg-gray-300={!disabled}
				class:hover:text-gray-700={!disabled}
				on:click|preventDefault|stopPropagation={() => dispatch('click', { page })}
			>
				{label}
			</button>
		{/each}
	</div>
	<!-- MOBILE: PREV <ACTIVE> NEXT Only -->
	<div class="md:hidden flex justify-center gap-x-1 {className}">
		{#each links as { current, disabled, active, label, page } (label)}
			{#if (current <= 4 ? page <= 7 : page >= current - 3 && page <= current + 3) || ['NEXT', 'PREVIOUS', '<', '<<', '>>', '>'].includes(label)}
				<button
					disabled={disabled ?? false}
					class="h-10 text-sm border rounded focus:outline-none flex justify-center items-center font-semibold"
					class:w-9={label.toString().length < 3}
					class:px-3={label.toString().length > 3}
					class:opacity-50={disabled && !active}
					class:opacity-70={active}
					class:text-black={!disabled || active}
					class:bg-white={!active}
					class:bg-primary={active}
					class:text-gray-200={disabled && !active}
					class:hover:bg-gray-300={!disabled}
					class:hover:text-gray-700={!disabled}
					on:click|preventDefault|stopPropagation={() => dispatch('click', { page })}
				>
					{label}
				</button>
			{/if}
		{/each}
	</div>
{/if}
